<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('newApp.BasicInfo.bi') }}</span>
    </div>
    <el-form class="common_form" label-position="left" ref="basicInformation" :rules="rules" label-width="174px"
             :model="formData"
    >
      <el-row>
        <!-- an - 活动编号 | bbbh - 报备编号 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="useType === 'activity' ? $t('newApp.BasicInfo.an') : $t('newApp.BasicInfo.bbbh')">
            <el-input v-model="formData.activityCode" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.Applicant')">
            <el-input v-model="formData.userData" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.ci')" prop="applyUserTel">
            <el-input v-model="formData.applyUserTel" :disabled="isReadOnly" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.at')">
            <el-input v-model="formData.applyTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.BasicInfo.cs')" prop="saler">
            <el-select :disabled="isReadOnly" v-model="formData.saler" filterable remote reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="remoteMethod" :loading="saleLoading"
                       @change="salerChange"
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import { arrayQuery, isNotEmpty } from '@/utils/utils';

export default {
  data () {
    let phoneNumberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error(`${this.$t('newApp.BasicInfo.peuci')}`));
      } else {
        callback();
      }
    };
    return {
      rules: {
        financialSystemCode: [
          { required: true, message: `${this.$t('newApp.BasicInfo.psafs')}`, trigger: 'change' }
        ],
        currencyCode: [
          { required: true, message: `${this.$t('newApp.BasicInfo.psac')}`, trigger: 'change' }
        ],
        applyUserTel: [
          { required: true, validator: this.$i18n.locale === 'zh-CN' ? phoneNumberValidator : null, trigger: 'blur' }
        ],
        saler: [
          { required: true, message: `${this.$t('newApp.BasicInfo.pstcs')}`, trigger: 'change' }
        ]
      },
      isReadOnly: false,
      formData: {},
      financialSystemList: [],
      currencyList: [],
      saleList: [],
      saleLoading: false,
      lang: localStorage.getItem('lang') || 'zh-CN'
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return null;
      }
    },
    useType: {
      type: String,
      default: 'activity'
    }
  },
  methods: {
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformation'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    financialSystemChange (val) {
      let financialSystemObj = arrayQuery(val, this.financialSystemList, 'comCode');
      this.formData.financialSystemName = financialSystemObj.comName;
    },
    salerChange (val) {
      let salerObj = arrayQuery(val, this.saleList, 'userId');
      this.formData.salerId = salerObj.userId;// 对应销售ID
      this.formData.salerName = salerObj.userName;// 对应销售姓名
      this.formData.salerDeptCode = salerObj.deptCode;// 对应销售部门code
      this.formData.salerDeptName = salerObj.deptName;// 对应销售部门名称
      this.getFinancialSystemList(1);
      // this.belongToSmb = salerObj.belongToSmb;
      // this.belongToQyw = salerObj.belongToQyw;
      this.$store.commit('newApplication/setSalerLoadFlag', 0);
      this.$store.commit('newApplication/setSalerData', salerObj);

      // 清除业务单元
      // if (!flag) {
      //   this.formData.businessUnitDisplayed = [];
      //   this.unitNameList = [];
      //   this.$nextTick(() => {
      //     this.$refs.basicInformationForm.clearValidate(['businessUnitDisplayed']);
      //   });
      //   this.getUnitNameList(this.formData.salerDeptCode);
      // }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        newApplicationFormApi.getSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    getActivityCode () {
      newApplicationFormApi.getActivityCode().then(res => {
        if (res.status === '200') {
          this.$set(this.formData, 'activityCode', res.data.code);
          this.$set(this.formData, 'applyTime', res.data.creatTime);
          this.$store.commit('newApplication/setActivityCode', res.data.code);
        }
      });
    },
    getFinancialSystemList (newFlag) {
      newApplicationFormApi.getFinancialSystemList(this.formData.salerId).then(res => {
        if (res.status === '200') {
          if (newFlag) {
            if (isNotEmpty(res.data)) {
              let defaultValFlag = res.data.some(item => {
                return item.comCode === '111';
              });
              // 如果新建申请 财务体系中没有福建 则默认第一个
              if (!defaultValFlag) {
                this.$set(this.formData, 'financialSystemCode', res.data[0].comCode);
                this.formData.financialSystemName = res.data[0].comName;
              } else {
                // 财务体系默认为福建
                this.$set(this.formData, 'financialSystemCode', '111');
                this.formData.financialSystemName = this.$t('general.fujian');
              }
            }
          }
          this.financialSystemList = res.data;
        }
      });
    },
    getCurrencyList () {
      this.formData.currencyCode = 'CNY'; // 货币默认为人民币
      newApplicationFormApi.getCurrencyList().then(res => {
        if (res.status === '200') {
          this.currencyList = res.data;
          let currencyObj = arrayQuery(this.formData.currencyCode, this.currencyList, 'currCode');
          this.formData.currencyType = currencyObj.currName;
          // 货币税率过滤
          this.formData.currFromRmbRate = currencyObj.currFromRmbRate;
        }
      });
    },
    getSalerData (userId, newFlag) {
      if (userId) {
        newApplicationFormApi.getSalesmanList(userId).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              const result = JSON.parse(JSON.stringify(res.data));
              const userIdIndex = result.findIndex(item => item.userId === userId);
              if (userIdIndex === -1) {
                let userInfo = this.$store.state.userInfo;
                result.unshift({
                  belongToSmb: userInfo.belongToSmb,
                  deptCode: userInfo.sysUser.deptCode,
                  deptName: userInfo.sysUser.deptName,
                  phone: userInfo.phone,
                  userId: userInfo.sysUser.userId,
                  userName: userInfo.sysUser.userName
                });
              } else {
                const currentUser = result.splice(userIdIndex, 1)[0];
                result.unshift(currentUser);
              }
              this.saleList = result.map(item => {
                return {
                  ...item,
                  combination: `${item.userName} / ${item.deptName}`
                };
              });
              const userIndex = this.saleList.findIndex(
                item => item.combination === this.formData.userData
              );
              const index = userIndex !== -1 ? userIndex : 0;
              this.$set(this.formData, 'saler', this.saleList[index].combination);
              this.formData.salerId = this.saleList[index].userId;// 对应销售ID
              this.formData.salerName = this.saleList[index].userName;// 对应销售姓名
              this.formData.salerDeptCode = this.saleList[index].deptCode;// 对应销售部门code
              this.formData.salerDeptName = this.saleList[index].deptName;// 对应销售部门名称
              // this.belongToSmb = this.saleList[0].belongToSmb;
              // this.belongToQyw = this.saleList[0].belongToQyw;
              this.getFinancialSystemList(newFlag);
              this.$store.commit('newApplication/setSalerLoadFlag', 1);
              this.$store.commit('newApplication/setSalerData', this.saleList[index]);
            }
          }
        });
      }
    }
  },
  mounted () {
    if (this.$route.query.activityCode) {
      // 如果是转申请页或者报备编辑页就全部禁止操作
      const pathList = ['/transferApplication', '/editReportApplication', '/activityTransferApplication', '/quickTransferApplication'];
      if (pathList.includes(this.$route.path)) {
        this.isReadOnly = true;
      }
      // 3：表示只能编辑费用归属
      if (this.$store.state.newApplication.editFlag === 3) {
        this.isReadOnly = true;
      }
      if (this.$route.path === '/editIndustryReportApplication') {
        this.isReadOnly = false;
      }

      let echoData = this.editEchoData.marketActivity;
      this.formData = {
        ...echoData,
        userData: `${echoData.applyUserName} / ${echoData.applyUserDeptName}`
      };
      // 获取财务体系列表
      this.getSalerData(this.formData.salerId);
    } else {
      let userInfo = this.$store.state.userInfo;
      // 申请人
      this.formData.userData = `${userInfo.sysUser.userName} / ${userInfo.sysUser.deptName}`;
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;

      // 联系方式
      this.$set(this.formData, 'applyUserTel', userInfo.phone);
      // 获取活动编码及申请时间
      this.getActivityCode();
      // 新建初始化 对应销售列表 默认当前登录人
      this.getSalerData(userInfo.sysUser.userId, 1);
    }
    // 获取货币种类列表
    this.getCurrencyList();
  }
};
</script>

<style scoped>

</style>
